var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    {
      attrs: {
        loading: _vm.$apollo.queries.profile.loading,
        hasData: !!_vm.profile,
      },
    },
    [
      !_vm.$apollo.queries.profile.loading
        ? _c(
            "FormWrapper",
            {
              attrs: {
                title: "Additional information",
                body: "Provide information about yourself",
              },
            },
            [
              _c(
                "FormGroup",
                { attrs: { title: "Skills" } },
                [
                  _c("SkillsMultiselect", {
                    model: {
                      value: _vm.skillsIds,
                      callback: function ($$v) {
                        _vm.skillsIds = $$v
                      },
                      expression: "skillsIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "FormGroup",
                { attrs: { title: "About" } },
                [
                  _c("FormTextarea", {
                    attrs: {
                      name: "description",
                      placeholder: "Enter information about yourself",
                    },
                    model: {
                      value: _vm.profile.about,
                      callback: function ($$v) {
                        _vm.$set(_vm.profile, "about", $$v)
                      },
                      expression: "profile.about",
                    },
                  }),
                ],
                1
              ),
              _c("UiButton", {
                staticClass: "block flex justify-end mt-2 pt-3",
                attrs: {
                  buttonText: "Save",
                  processing: _vm.$apollo.queries.profile.loading,
                },
                on: { click: _vm.updateProfile },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }